var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    fill: "#FF1C26",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 28C26.1046 28 27 27.1046 27 26C27 24.8954 26.1046 24 25 24C23.8954 24 23 24.8954 23 26C23 27.1046 23.8954 28 25 28ZM29 26C29 28.2091 27.2091 30 25 30C22.7909 30 21 28.2091 21 26C21 23.7909 22.7909 22 25 22C27.2091 22 29 23.7909 29 26Z",
    fill: "#FF1C26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 20C29.2425 20 28.5499 19.572 28.2111 18.8944L28.0403 18.5528C27.8709 18.214 27.5247 18 27.1459 18H22.8541C22.4753 18 22.1291 18.214 21.9597 18.5528L21.7889 18.8944C21.4501 19.572 20.7575 20 20 20H18C17.4477 20 17 20.4477 17 21V31C17 31.5523 17.4477 32 18 32H32C32.5523 32 33 31.5523 33 31V21C33 20.4477 32.5523 20 32 20H30ZM30 18L29.8292 17.6584C29.321 16.642 28.2822 16 27.1459 16H22.8541C21.7178 16 20.679 16.642 20.1708 17.6584L20 18H18C16.3431 18 15 19.3431 15 21V31C15 32.6569 16.3431 34 18 34H32C33.6569 34 35 32.6569 35 31V21C35 19.3431 33.6569 18 32 18H30Z",
    fill: "#FF1C26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 22.5C31.5 23.0523 31.0523 23.5 30.5 23.5C29.9477 23.5 29.5 23.0523 29.5 22.5C29.5 21.9477 29.9477 21.5 30.5 21.5C31.0523 21.5 31.5 21.9477 31.5 22.5Z",
    fill: "#FF1C26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.d5565749ffee71e904e286bda81f8069.svg";
export { ForwardRef as ReactComponent };